/**
 * @copyright @2022 Techechelons Infosolutions Pvt. Ltd. All rights reserved.
 * @description Page to create styles for account popover component.
 * --------------------------------------------------------------------
 * Creation Details
 * @author Naishad Vaishnav
 * Date Created: 17/Nov/2022
 * FDO Ref:
 * TDO Ref:
 * RTM Ref:
 * Test Case Ref:
 */

// ----------------------------------------------------------------------

export default {
  accountPopover: {
    width: 230
  },
  popoverProfile: {
    my: 1.5,
    px: 2.5,
    flexWrap: 'nowrap'
  },
  popoverMenuItem: {
    typography: 'body2',
    py: 1,
    px: 2.5
  },
  modeMenuItem: {
    cursor: 'default',
    '&:hover': {
      background: 'none'
    }
  },
  profileDivider: {
    my: 1
  },
  logoutDivider: {
    marginBottom: '0px !important'
  },
  logout: {
    width: '100%',
    justifyContent: 'center'
  }
};
